import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { cantones } from '../data/mockData';
import { Card } from './Card';
interface ZoneSelectorProps {
  onSelectCanton: (id: string) => void;
}
export function ZoneSelector({
  onSelectCanton
}: ZoneSelectorProps) {
  return <section className="py-24 px-4 bg-bg-secondary relative overflow-hidden" data-id="element-363">
      {/* Subtle background */}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-[0.03]" data-id="element-364">
        <img src="https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=1400&q=80" alt="Café y montañas" className="w-full h-full object-cover" data-id="element-365" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-366">
        <div className="text-center mb-16" data-id="element-367">
          <h2 className="text-4xl md:text-5xl font-heading uppercase tracking-wide text-white mb-4" data-id="element-368">
            Zona de <span className="text-gradient-fire" data-id="element-369">Los Santos</span>
          </h2>
          <p className="font-body text-brand-gold text-lg font-medium" data-id="element-370">
            Tarrazú · Dota · León Cortés
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-371">
          {cantones.map((canton, index) => <motion.div key={canton.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={() => onSelectCanton(canton.id)} className="cursor-pointer h-full" data-id="element-372">
              <Card className="h-full p-8 flex flex-col items-center text-center group" data-id="element-373">
                <div className="w-16 h-16 rounded-full bg-bg-primary border border-border flex items-center justify-center mb-6 group-hover:border-brand-orange/50 transition-colors" data-id="element-374">
                  <FlameIcon className="w-8 h-8 text-brand-orange" data-id="element-375" />
                </div>
                <h3 className="font-heading text-4xl text-white mb-2 group-hover:text-brand-gold transition-colors" data-id="element-376">
                  {canton.name}
                </h3>
                <p className="font-body text-sm text-text-muted mb-4 font-medium uppercase tracking-wider" data-id="element-377">
                  {canton.fullName}
                </p>
                <p className="font-body text-sm text-text-secondary mb-6 flex-1" data-id="element-378">
                  {canton.description}
                </p>
                <div className="mt-auto bg-bg-primary px-4 py-2 rounded-full border border-border" data-id="element-379">
                  <span className="font-body text-sm font-bold text-brand-gold" data-id="element-380">
                    {canton.restaurantCount} lugares
                  </span>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}